import React, { Component } from "react";
import { connect } from "react-redux";
import format from "date-fns/format";
import { withRouter } from "react-router-dom";
import { openModal } from "../../../actions/modalAction";
import { fetchPropCom } from "../../../actions/propertyComAction_Dwk";

import writtenNumber from "written-number";
import { Icon } from "semantic-ui-react";
import Loading from "../../common/Loading";
import AreaUnitConverter from "../../common/UnitConverter/AreaUnitConverter";

class PropComDetail extends Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.fetchPropCom(id);
    window.scroll(0, 0);
  }

  capitalizeFirst = (input) => {
    var words = input.split(" ");
    var CapitalizedWords = [];
    words.forEach((element) => {
      CapitalizedWords.push(
        element[0].toUpperCase() + element.slice(1, element.length)
      );
    });
    return CapitalizedWords.join(" ");
  };
  renderLoadingOrNoProp = () => {
    if (this.props.propcom === null) {
      return <Loading />;
    }

    if (!this.props.propcom) {
      return (
        <span style={{ fontSize: "18px", color: "teal" }}>
          <b>PROPERTY DETAIL NOT AVAILABLE </b>
        </span>
      );
    }
  };
  //********************************* */
  render() {
    const {
      propertyFor,
      propertyType,
      bedroom,
      bathroom,
      store,
      furnishedStatus,
      aproxValueOfWork,
      expectedPrice,
      // occupancyStatus,
      // freehold,
      facing,
      entry,
      Overlooking,
      floorNo,
      totalFloors,
      projectType,
      projectName,
      address,
      locality,
      // city,
      landmarks,
      description,
      // createdAt,
      //furnishing details
      interior,
      ac,
      fan,
      others,
      washroomCommon,
      washroomPersonal,
      pantryPersonal,

      //powerBackUp,
      length,
      breadth,
      parking,
      reserveParking,
      visitorParking,

      expectedRent,
      securityDeposit,
      maintenanceCharges,
      unitMaintenanceCharges,
      otherCharges,
      unitOtherCharges,
      companyLease,
      agreement,
      //
      typeOfOwnership,
      loanOfferedBy,
      status,
      possession,
      category,
      areaPlot,
      areaPlotUnit,
      areaCarpet,
      areaCarpetUnit,
      areaSuper,
      areaSuperUnit,
      areaBuiltUp,
      areaBuiltUpUnit,
      liftsInTheTower,
      amenities,
      phoneOfContactPerson,
      //@@

      // _id,
    } = this.props.propcom !== null && this.props.propcom;

    const poss =
      Date.parse(possession) < Date.now() ? (
        "Immediate"
      ) : (
        <span>{possession && format(new Date(possession), "dd-MM-yyyy")}</span>
      );

    //******************
    const renderAmenities = () => {
      return amenities.map((item) => {
        return (
          <span key={item} className="card-amenity">
            {" "}
            <b>{item} </b>
          </span>
        );
      });
    };

    // //********* */
    // const renderFloorNo = () => {
    //   if (showFloorNo === "Yes") {
    //     return floorNo;
    //   } else {
    //     if (floorNo === "Ground" || floorNo === "1st" || floorNo === "2nd") {
    //       return "Between Ground - 2nd";
    //     }
    //     if (floorNo === "Top" || floorNo === "3rd" || floorNo === "4th") {
    //       return "Between 3rd - Top";
    //     }
    //   }
    // };
    //********* */
    return (
      <div>
        <div className="font-family-Roboto maindiv-820">
          <div>
            {/* create Modal end*/}

            <div
              className="card-attached border-radius-top "
              style={{
                display: "flex",
                textAlign: "center",
                backgroundColor: "skyblue",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: "10%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={this.props.handleDetailModalClose}
                  className="back-btn"
                >
                  <Icon name="arrow left" />
                </button>
              </div>
              <div
                className="font-20B pxy-10"
                style={{
                  flex: "90%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {propertyType === "Commercial Land /Plot" && (
                  <span>
                    {areaPlot} {areaPlotUnit}
                  </span>
                )}
                {propertyType !== "Commercial Land /Plot" && areaCarpet > 0 && (
                  <span>{areaCarpet} sq ft</span>
                )}
                <span>
                  {propertyType && (
                    <span>
                      <span> {propertyType} </span>
                      <span> for </span>
                    </span>
                  )}{" "}
                  {propertyFor && (
                    <span>
                      <span> {propertyFor} </span>
                      <span> in {projectName} </span>
                    </span>
                  )}
                </span>
              </div>
            </div>

            <div className="card-attached border-radius-bottom pxy-20">
              {this.renderLoadingOrNoProp()}

              {/*  */}
              <div>
                {propertyFor === "SALE" && expectedPrice > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Price</b>
                    </div>
                    <div className="main">
                      <Icon className="rupee"></Icon>
                      <b> {expectedPrice}</b>
                      <b>
                        {" "}
                        (
                        {this.capitalizeFirst(
                          writtenNumber(expectedPrice, {
                            lang: "enIndian",
                          })
                        )}
                        ){" "}
                      </b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {propertyFor !== "SALE" && expectedRent > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Rent</b>
                    </div>
                    <div className="main">
                      <Icon className="rupee"></Icon>
                      <b> {expectedRent}</b>
                      <b>
                        {" "}
                        (
                        {this.capitalizeFirst(
                          writtenNumber(expectedRent, {
                            lang: "enIndian",
                          })
                        )}
                        ){" "}
                      </b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {propertyFor !== "SALE" && securityDeposit > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Security Deposit</b>
                    </div>
                    <div className="main">
                      <Icon className="rupee"></Icon>
                      <b> {securityDeposit}</b>
                      <b>
                        {" "}
                        (
                        {this.capitalizeFirst(
                          writtenNumber(securityDeposit, {
                            lang: "enIndian",
                          })
                        )}
                        ){" "}
                      </b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {propertyFor !== "SALE" && maintenanceCharges > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Maintenance Charges</b>
                    </div>
                    <div className="main">
                      <Icon className="rupee"></Icon>
                      <b> {maintenanceCharges}</b>
                      <b>
                        {" "}
                        (
                        {this.capitalizeFirst(
                          writtenNumber(maintenanceCharges, {
                            lang: "enIndian",
                          })
                        )}
                        ){" "}
                      </b>
                      {propertyFor !== "SALE" && unitMaintenanceCharges && (
                        <b>{unitMaintenanceCharges}</b>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div>
                {propertyFor !== "SALE" && otherCharges > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Other Charges</b>
                    </div>
                    <div className="main">
                      <Icon className="rupee"></Icon>
                      <b> {otherCharges}</b>
                      <b>
                        {" "}
                        (
                        {this.capitalizeFirst(
                          writtenNumber(otherCharges, {
                            lang: "enIndian",
                          })
                        )}
                        ){" "}
                      </b>
                      {propertyFor !== "SALE" && unitOtherCharges && (
                        <b>{unitOtherCharges}</b>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div>
                {propertyFor && (
                  <div className="row">
                    <div className="side">
                      <b>Property For</b>
                    </div>
                    <div className="main">
                      <b>{propertyFor}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {propertyType && (
                  <div className="row">
                    <div className="side">
                      <b>Type Of Property</b>
                    </div>
                    <div className="main">
                      <b>{propertyType}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {category && (
                  <div className="row">
                    <div className="side">
                      <b>Category</b>
                    </div>
                    <div className="main">
                      <b>{category}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {status && (
                  <div className="row">
                    <div className="side">
                      <b>Status</b>
                    </div>
                    <div className="main">
                      <b>{status}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {possession && (
                  <div className="row">
                    <div className="side">
                      <b>Possession</b>
                    </div>
                    <div className="main">
                      <b>{poss}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {bedroom && (
                  <div className="row">
                    <div className="side">
                      <b>Rooms</b>
                    </div>
                    <div className="main">
                      <b>{bedroom}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {bathroom && (
                  <div className="row">
                    <div className="side">
                      <b>Washrooms</b>
                    </div>
                    <div className="main">
                      <b>{bathroom}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {store && (
                  <div className="row">
                    <div className="side">
                      <b>Store</b>
                    </div>
                    <div className="main">
                      <b>{store}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {length > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Length </b>
                    </div>
                    <div className="main">
                      <b>{length} Ft</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {breadth > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Breadth </b>
                    </div>
                    <div className="main">
                      <b>{breadth} Ft</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {areaCarpet > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Carpet Area</b>
                    </div>
                    <AreaUnitConverter val={areaCarpet} unit={areaCarpetUnit} />
                  </div>
                )}
              </div>
              <div>
                {areaBuiltUp > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>BuiltUp Area</b>
                    </div>
                    <AreaUnitConverter
                      val={areaBuiltUp}
                      unit={areaBuiltUpUnit}
                    />
                  </div>
                )}
              </div>
              <div>
                {areaSuper > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Super Area</b>
                    </div>
                    <AreaUnitConverter val={areaSuper} unit={areaSuperUnit} />
                  </div>
                )}
              </div>
              <div>
                {areaPlot > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Plot Area</b>
                    </div>
                    <AreaUnitConverter val={areaPlot} unit={areaPlotUnit} />
                  </div>
                )}
              </div>
              {/* furnishing details  START*/}
              <div>
                {furnishedStatus && (
                  <div className="row">
                    <div className="side">
                      <b>Furnished Status</b>
                    </div>
                    <div className="main">
                      <b>{furnishedStatus}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {aproxValueOfWork > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Value Of Work</b>
                    </div>
                    <div className="main">
                      <Icon className="rupee"></Icon>
                      <b>{aproxValueOfWork}</b>
                      <b>
                        {" "}
                        (
                        {this.capitalizeFirst(
                          writtenNumber(aproxValueOfWork, {
                            lang: "enIndian",
                          })
                        )}
                        ) approx.
                      </b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {interior && (
                  <div className="row">
                    <div className="side">
                      <b>Interior</b>
                    </div>
                    <div className="main">
                      <b>{interior}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {ac && (
                  <div className="row">
                    <div className="side">
                      <b>AC</b>
                    </div>
                    <div className="main">
                      <b>{ac}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {fan && (
                  <div className="row">
                    <div className="side">
                      <b>Fan</b>
                    </div>
                    <div className="main">
                      <b>{fan}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {others && (
                  <div className="row">
                    <div className="side">
                      <b>Other Item</b>
                    </div>
                    <div className="main">
                      <b>{others}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {washroomCommon && (
                  <div className="row">
                    <div className="side">
                      <b>Common Washroom</b>
                    </div>
                    <div className="main">
                      <b>{washroomCommon}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {washroomPersonal && (
                  <div className="row">
                    <div className="side">
                      <b>Personal Washroom</b>
                    </div>
                    <div className="main">
                      <b>{washroomPersonal}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {pantryPersonal && (
                  <div className="row">
                    <div className="side">
                      <b>Personal Pantry</b>
                    </div>
                    <div className="main">
                      <b>{pantryPersonal}</b>
                    </div>
                  </div>
                )}
              </div>

              {/* furnishing details  END*/}
              {/* other rent details  START*/}

              <div>
                {companyLease && (
                  <div className="row">
                    <div className="side">
                      <b>Company Lease</b>
                    </div>
                    <div className="main">
                      <b>{companyLease}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {agreement && (
                  <div className="row">
                    <div className="side">
                      <b>Agreement</b>
                    </div>
                    <div className="main">
                      <b>{agreement}</b>
                    </div>
                  </div>
                )}
              </div>

              {/* other rent details  END*/}

              <div>
                {entry && (
                  <div className="row">
                    <div className="side">
                      <b>Entry</b>
                    </div>
                    <div className="main">
                      <b>{entry}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {facing && (
                  <div className="row">
                    <div className="side">
                      <b>Facing</b>
                    </div>
                    <div className="main">
                      <b>{facing}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {Overlooking && (
                  <div className="row">
                    <div className="side">
                      <b>Overlooking</b>
                    </div>
                    <div className="main">
                      <b>{Overlooking}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {parking && (
                  <div className="row">
                    <div className="side">
                      <b>Parking</b>
                    </div>
                    <div className="main">
                      <b>{parking}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {reserveParking && (
                  <div className="row">
                    <div className="side">
                      <b>Reserve Parking</b>
                    </div>
                    <div className="main">
                      <b>{reserveParking}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {visitorParking && (
                  <div className="row">
                    <div className="side">
                      <b>Visitor Parking</b>
                    </div>
                    <div className="main">
                      <b>{visitorParking}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {floorNo && (
                  <div className="row">
                    <div className="side">
                      <b>Floor No.</b>
                    </div>
                    <div className="main">
                      <b>{floorNo}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {totalFloors && (
                  <div className="row">
                    <div className="side">
                      <b>Total Floors</b>
                    </div>
                    <div className="main">
                      <b>{totalFloors}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {liftsInTheTower && (
                  <div className="row">
                    <div className="side">
                      <b>Lifts In The Tower</b>
                    </div>
                    <div className="main">
                      <b>{liftsInTheTower}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {projectType && (
                  <div className="row">
                    <div className="side">
                      <b>Project Type</b>
                    </div>
                    <div className="main">
                      <b>{projectType}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {address && (
                  <div className="row">
                    <div className="side">
                      <b>Address</b>
                    </div>
                    <div className="main">
                      <b>{address}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {projectName && (
                  <div className="row">
                    <div className="side">
                      <b>Complex / Project Name</b>
                    </div>
                    <div className="main">
                      <b>{projectName}</b>
                    </div>
                  </div>
                )}
              </div>

              <div>
                {locality && (
                  <div className="row">
                    <div className="side">
                      <b>Locality</b>
                    </div>
                    <div className="main">
                      <b>{locality}</b>
                    </div>
                  </div>
                )}
              </div>
              {/* <div>
                {city && (
                  <div className="row">
                    <div className="side">
                      <b>City / District</b>
                    </div>
                    <div className="main">
                      <b>{city}</b>
                    </div>
                  </div>
                )}
              </div> */}
              <div>
                {landmarks && (
                  <div className="row">
                    <div className="side">
                      <b>Landmarks</b>
                    </div>
                    <div className="main">
                      <b>{landmarks}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {typeOfOwnership && (
                  <div className="row">
                    <div className="side">
                      <b>Type Of Ownership</b>
                    </div>
                    <div className="main">
                      <b>{typeOfOwnership}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {loanOfferedBy && (
                  <div className="row">
                    <div className="side">
                      <b>Loan Offered By</b>
                    </div>
                    <div className="main">
                      <b>{loanOfferedBy}</b>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {phoneOfContactPerson && (
                  <div className="row">
                    <div className="side">
                      <b>Phone Of Contact Person</b>
                    </div>
                    <div className="main">
                      <b>{phoneOfContactPerson}</b>
                    </div>
                  </div>
                )}
              </div>
              {/* 
              <div>
                {createdAt && (
                  <div className="row">
                    <div className="side">
                      <b>Advertised On</b>
                    </div>
                    <div className="main">
                      <b>{format(new Date(createdAt), "dd-MM-yyyy")}</b>
                    </div>
                  </div>
                )}
              </div> */}
              <div>
                {amenities && amenities.length > 0 && (
                  <div className="row">
                    <div className="side">
                      <b>Amenities</b>
                    </div>
                    <div className="main">{renderAmenities()}</div>
                  </div>
                )}
              </div>
              <div>
                {description && (
                  <div className="rowERP-projName">
                    <div className="side">
                      <b>About/USP OF Property</b>
                    </div>
                    <div className="main display-linebreak">
                      <b>{description}</b>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <br />

            <br />
            <br />
          </div>
        </div>
      </div>

      //**********************************
    );
  }
}
function mapStateToProps(state) {
  return {
    state,
    propcom: state.dwk_com_property.propcom,
    userA: state.auth.userA,
  };
}

export default connect(mapStateToProps, { fetchPropCom, openModal })(
  withRouter(PropComDetail)
);
